const VideoItems = [
    {
        title: "Vibraphone Etude No. 1",
        url: "https://www.youtube.com/watch?v=b12NKfkc1yk&t=377s",
        thumbnail: "src/srcAssets/images/MArkSammich.png"
    },
    {
        title: "The Showmen official Music Video, animation by Derek Barber",
        url: "https://youtu.be/vsvdN4U_UQc?si=TnIqyh6geN6Em5I2",
        thumbnail: "src/srcAssets/images/ShowmenThumb.png"
    },
    {
        title: "Levitator Trio @ Bird and Beckett",
        url: "https://www.youtube.com/live/VTK0IJGRkUE?si=gSvVszEEbwQzWzLH"
    },
    {
        title: "The Lost Shapes play 'The Bar Men'",
        url: "https://youtu.be/qQgwJch1ivs?si=9-QGnySIZhAEpOFf"
    },
    {
        title: "lisa Mezzacappa 5(ish) @ Bird and Beckett",
        url: "https://www.youtube.com/live/gsV2iDX_DeQ?si=Geb0ymls_MfO-GHb"
    },
    {
        title: "Levitator Trio playing 'Warm and Thum'",
        url: "https://youtu.be/EgRUlyjNWIE?si=2ExYWG-XtJvSjgxq"
    },
    {
        title: "Improvisation",
        url: "https://youtu.be/HOI1bjIZNkQ?si=Es9JV3hhFKWr2qmG"
    },

    {
        title: "China Residency Update",
        url: "https://youtu.be/BlYc6YSGYVc?si=fp43Wk8rpyyWFuXg"
    },
    {
        title: "Inner Movements - Lockdown Festival",
        url: "https://www.youtube.com/live/nB9eOxwqkJU?si=P2gVnEDtUYgWcb_Y"
    },
    {
        title: "Progression Shed",
        url: "https://youtu.be/qBqJBnyvELg?si=0_RLf8UMddWF-Gsx"
    },
    {
        title: "the dogs go nutz while we improvise",
        url: "https://youtu.be/G8RzzRgFb6M"
    },
    {
        title: "Lockdown Festival V",
        url: "https://www.youtube.com/watch?v=hNbiJoXGxLA"
    }
]

export default VideoItems;